import React from 'react';
import ReactDom from 'react-dom/client';
import '@mantine/dates/styles.css';
import '@mantine/core/styles.css';
import '@mantine/core/styles/baseline.css';
import '@mantine/core/styles/default-css-variables.css';
import '@mantine/core/styles/global.css';
import './index.css';
import { MantineProvider } from '@mantine/core';
import { CookiesProvider } from 'react-cookie';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from './libs/reactQueryConfig';
import { App } from './routes/App';
import { theme } from './theme/mantineTheme';
import '@mantine/charts/styles.css';
import { DatesProvider } from '@mantine/dates';
import { ContextProvider } from './routes/ContextProvider';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const root = ReactDom.createRoot(
	document.getElementById('root') as HTMLElement,
);

root.render(
	<CookiesProvider>
		<React.StrictMode>
			<ContextProvider>
				<MantineProvider
					defaultColorScheme={'light'}
					theme={theme}
					withGlobalClasses
				>
					<DatesProvider settings={{ locale: 'gb' }}>
						<BrowserRouter>
							<QueryClientProvider client={queryClient}>
								<App />
							</QueryClientProvider>
						</BrowserRouter>
					</DatesProvider>
				</MantineProvider>
			</ContextProvider>
		</React.StrictMode>
	</CookiesProvider>,
);
